import React, { Fragment, useEffect, useState, useRef, useSelector } from "react";
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Label,
  FormGroup,
  Form,
  Badge
} from "reactstrap";
import { fetchCommissionCalculation, calculateBulkCommission, processCommission, verifyInvoiceOtp, checkCommissionInvoice, sendOtpForInvoiceVerification, verifyGroupInvoiceOtp, processCommissionForGroupInvoice, sendInvoiceLink } from "../../../api"; // Ensure API calls are correctly defined
import GetLoader from "../../common/getLoader";
import { getFromLocalStorage } from "../../../hooks/useLocalStorage";
import convertToRupees from "../../../utilities/convertToRupees";
import { toast } from "react-toastify";
import OtpInput from 'react-otp-input';
import { useForm } from "react-hook-form";
import FileUploadComponent from "../../common/FileUpload";
import { USE_V2_WEBSOCKET } from "../../../constant";
import usePaymentWebSocket from '../../../hooks/usePaymentWebSocket';

const ClaimInvoice = ({ isOpen, toggle, selectedDocumentIds,selectedInvoiceIds, offlinePayment, partnerInfo, isBulk = false, groupId }) => {
  console.log({
    isOpen,
    selectedDocumentIds,
    selectedInvoiceIds,
    offlinePayment,
    partnerInfo,
    isBulk,
    groupId
});
  const [calculation, setCalculation] = useState(null);
  const [loading, setLoading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [redirecting, setRedirecting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const [documentCommissionDetails, setDocComDetails] = useState([]);
  const [wantInvoice, setWantInvoice] = useState(null);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [remark, setRemark] = useState();
  const [termsModalOpen, setTermsModalOpen] = useState(false);
  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [mobileNoModalOpen, setMobileNoModalOpen] = useState(false);
  // const { data } = useSelector((state) => state.login);
  const [state, setState] = useState({ otp: '', mobileNumber: "" });
  const [invoiceNumber, setInvoiceNo] = useState("");
  const [txnid, setTxnid] = useState(null); // Used for dynamic WebSocket connection
  const componentRef = useRef();
  const { register, handleSubmit, errors, setValue, trigger, getValues } = useForm();
  console.log("remark and file ", getValues("remark")?.trim(), getValues("file")?.length)
  const [termsFileUrl, setTermsFileUrl] = useState("");
  // ✅ Get Partnership ID from Local Storage
  const user = getFromLocalStorage("user");
  const roleKey = getFromLocalStorage("ROLE")?.key;
  const role_id = getFromLocalStorage("ROLE")?.role_id;
  const partnership_id = roleKey == "SALES_MANAGER" ? partnerInfo?.partnership_id : user?.partnership_id;
  const businessPartnerInfo = roleKey == "SALES_MANAGER" ? partnerInfo : user.partnerInfo;
  const isGSTReg = roleKey == "SALES_MANAGER" ? partnerInfo?.user?.is_gst_registered || false : user?.partnerInfo.user.is_gst_registered || false;
  // ✅ Convert selectedDocumentIds object to an array
  const documentIdsArray = Object.keys(selectedDocumentIds).map(Number);
  const [offlineFile, setOfflineFile] = useState(null);
  const toggleTermsModal = () => setTermsModalOpen(!termsModalOpen);
  const toggleOtpModal = () => setOtpModalOpen(!otpModalOpen);
  const toggleMobileNoModal = () => setMobileNoModalOpen(!mobileNoModalOpen);
  const handleAgreeClick = () => {
    setTermsAccepted(true);
    toggleTermsModal();
  };
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [confirmDetails, setConfirmDetails] = useState(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    setEmail(user?.email || "");
    setMobileNumber(user?.phone_no || "");
  }, []);

  // Connect WebSocket dynamically when txnid is available
  const { paymentEvent, clearEvent } = usePaymentWebSocket(txnid, USE_V2_WEBSOCKET && !!txnid);

  useEffect(() => {
    if (paymentEvent) {
      if (paymentEvent.status === 'SUCCESS' || paymentEvent.status?.toLowerCase() === 'completed') {
        setProcessing(false);
        setRedirecting(false);
        if (otpModalOpen) setOtpModalOpen(false);
        toggle(); // Close modal

        window.dispatchEvent(new CustomEvent('show-global-payment-modal', {
          detail: {
            status: 'SUCCESS',
            message: 'Your payment was processed successfully!',
            documentInfo: paymentEvent.payload?.amount || calculation?.net_payable_amount || 0,
            documentLabel: 'Amount Paid (INR):'
          }
        }));

        window.dispatchEvent(new Event('refresh-invoices')); // Instruct parent to refresh
      } else if (paymentEvent.status === 'FAILED' || paymentEvent.status?.toLowerCase() === 'failed') {
        setProcessing(false);
        setRedirecting(false);
        if (otpModalOpen) setOtpModalOpen(false);
        toggle(); // Close modal

        window.dispatchEvent(new CustomEvent('show-global-payment-modal', {
          detail: {
            status: 'FAILED',
            message: 'Payment failed! Please try again.',
            documentInfo: paymentEvent.payload?.amount || calculation?.net_payable_amount || 0,
            documentLabel: 'Amount Attempted (INR):'
          }
        }));
      }
      clearEvent();
    }
  }, [paymentEvent, toggle, otpModalOpen, clearEvent]);
  const handleChange = (otp) => setState({ otp });
  const handleInvoiceNumberChange = (invoiceNumber) => setInvoiceNo(invoiceNumber)
  const handleMobileNumberChange = (mobileNumber) => setState({ mobileNumber })

  const setOtpResquest = () => {
    if (isGSTReg) {
      checkInvoiceDuplication()
    } else {
      // toggleMobileNoModal();
      submitNumberToGetOtp()
    }
  }



  const checkInvoiceDuplication = async () => {
    setLoading(true);
    try {
      const response = await checkCommissionInvoice({
        partnership_id,
        partner_invoice_number: invoiceNumber
      })

      if (response?.data.code === 200) {
        toast.success(response?.data.msg);
        // toggleMobileNoModal()
        submitNumberToGetOtp()
      }

      if (response?.data.code === 400) {
        toast.error(response?.data.error);
      }

    } catch (error) {
      const errorMsg =
        error.response?.data?.error || "An error occurred while fetching data.";
      toast.error(errorMsg);
    }
    setLoading(false);
  }

  const submitNumberToGetOtp = async () => {
    setLoading(true);
    try {
      const data = roleKey == "SALES_MANAGER" ? {
        mobileNumber: state.mobileNumber,
        partnership_id: partnership_id
      } : {
        mobileNumber: state.mobileNumber
      };
      const response = await sendOtpForInvoiceVerification(data)

      if (response?.data.code === 200) {
        toast.success(response?.data.msg);
        toggleOtpModal();
      }

      if (response?.data.code === 400) {
        toast.error(response?.data.error);
      }

    } catch (error) {
      const errorMsg =
        error.response?.data?.error || "An error occurred while fetching data.";
      toast.error(errorMsg);
    }
    setLoading(false);
  }

  const handleSendLink = async () => {
    try {
      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      // Mobile validation (10 digits)
      const mobileRegex = /^[0-9]{10}$/;

      if (!email.trim()) {
        toast.error("Email is required");
        return;
      }

      if (!emailRegex.test(email.trim())) {
        toast.error("Please enter a valid email address");
        return;
      }

      if (!mobileNumber.trim()) {
        toast.error("Mobile number is required");
        return;
      }

      if (!mobileRegex.test(mobileNumber.trim())) {
        toast.error("Please enter a valid 10-digit mobile number");
        return;
      }

      const payload = {
        "reqEmail": email,
        "reqPhone": mobileNumber,
        "invoice_ids": selectedInvoiceIds,
        "role_id": role_id,
        "isNormalWallet": false,
        "groupId": groupId,
        "invoiceNumbers": Object.keys(selectedDocumentIds),
        "gstInvoiceNo": invoiceNumber
      };

      const response = await sendInvoiceLink(payload);
      // console.log(response, "sendLink response");

      // Close modal
      toggle();

      if (response?.data?.code === 200) {
        toast.success("Payment link sent successfully");
      }
    } catch (error) {
      toast.error("Failed to send payment link");
    }
  };

  // ✅ Fetch commission calculation from backend
  const fetchCalculation = async () => {
    if (!partnership_id || Object.keys(selectedDocumentIds).length === 0) return;
    setLoading(true);
    setErrorMessage("");
    setCalculation(null);

    try {
      let response;
      if (isBulk) {
        const invoiceNumbers = Object.keys(selectedDocumentIds);
        response = await calculateBulkCommission({
          invoice_numbers: invoiceNumbers,
        });
      } else {
        response = await fetchCommissionCalculation({
          document_ids: documentIdsArray,
          partnership_id,
          role_id: role_id
        });
      }

      if (response?.data?.result) {

        const result = response.data.result;

        setCalculation(result);
        console.log("Calculation response:", response.data.result);

        let documents = result.documentTxnList || [];

        if (result.total_cancelled_documents > 0) {
          documents = [
            ...documents,
            ...(result.documentTxnList_for_cancelled_documents || [])
          ];
        }

        setDocComDetails(documents);

      } else {
        throw new Error("Invalid response from server.");
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.error || "An error occurred while fetching data.";
      setErrorMessage(errorMsg);
      toast.error(errorMsg);
    }
    setLoading(false);
  };

  const offlineProcessCommission = async (file, remark) => {

    try {
      let payload, response;
      if (isBulk) {
        payload = {
          invoice_number: Object.keys(selectedDocumentIds),
          partnership_id,
          supportedFile: file,
          isOfflinePayment: true,
          partner_invoice_number: invoiceNumber || "",
          remark: remark || "",
        };

        console.log("Payload for Offline Cutnpay Payment is bulk true:", payload);

        response = await processCommissionForGroupInvoice({
          ...payload
        });

        console.log("Response of Offline Cutnpay Payment is bulk true:", response);

      } else {
        payload = {
          document_ids: documentIdsArray,
          partnership_id,
          supportedFile: file,
          isOfflinePayment: true,
          partner_invoice_number: invoiceNumber || "",
          remark: remark || "",
        };

        console.log("Payload for Offline Cutnpay Payment:", payload);

        response = await processCommission({
          ...payload
        });

        console.log("Response of Offline Cutnpay Payment:", response);
      }

      if (response?.data?.result) {
        const ticketNumber = response.data.result.ticketNumber;
        toast.success(`Tikcet ${ticketNumber} has been created successfully`);
      } else {
        throw new Error("Invalid response from server.");
      }
      toggle()
    } catch (error) {
      const errorMsg =
        error.response?.data?.error || "An error occurred while fetching data.";
      setErrorMessage(errorMsg);
      toast.error(errorMsg);
      toggle()
    }

  }

  const handleOfflineSubmit = async () => {
    // Get all form values
    const formValues = getValues();
    if (!formValues.remark || formValues.remark.trim() === "") {
      toast.error("Please enter a remark before submitting.");
      return;
    }
    if (!formValues.file || (Array.isArray(formValues.file) && formValues.file.length === 0)) {
      toast.error("Please upload a file before submitting.");
      return;
    }
    console.log("Form Values:", formValues);
    await offlineProcessCommission(formValues.file, formValues.remark)

  };

  // ✅ Fetch data when modal opens
  useEffect(() => {
    // if(documentIdsArray.length < 31){
    if (isOpen) {
      fetchCalculation();
      setActiveStep(0);
    }
    // }else{
    //   isOpen = false;
    //   toast.error(`You can't make payment of more than 30 documents at a time. Seleted documents count is ${documentIdsArray.length}`)
    // }

  }, [isOpen]);

  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  // ✅ Process commission and redirect to PayU
  const handleProceedToPay = async () => {
    if (!calculation) return;

    setProcessing(true);
    // toast.info("Processing commission, please wait...");

    try {
      let payload;
      if (isBulk) {
        payload = {
          invoice_numbers: Object.keys(selectedDocumentIds),
          partnership_id,
        };
      } else {
        payload = {
          document_ids: documentIdsArray,
          partnership_id,
        };
      }

      const response = await processCommission(payload);

      if (response?.data?.result.paymentResponse?.payuUrl && response?.data?.result?.paymentResponse?.payUPayload) {
        const payuUrl = response.data.result.paymentResponse.payuUrl;
        const payuPayload = response.data.result.paymentResponse.payUPayload;
        if (payuPayload?.txnid) setTxnid(payuPayload.txnid);

        console.log("💳 [handleProceedToPay] Amount being sent to PayU:", payuPayload?.amount);

        toast.success("Redirecting to payment gateway...");
        setRedirecting(true);

        // Create a dynamic form for redirection with full payload
        const form = document.createElement("form");
        form.method = "POST";
        form.action = payuUrl;

        // Append all payload parameters as hidden inputs
        Object.entries(payuPayload).forEach(([key, value]) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          input.value = value;
          form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit(); // Submit the form to PayU
      } else {
        throw new Error("Failed to process commission.");
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.error || "Failed to process commission.";
      setErrorMessage(errorMsg);
      toast.error(errorMsg);
    }

    setProcessing(false);
  };

  const handleProceedToPayViaOtp = async () => {
    if (!calculation) return;

    setProcessing(true);
    // toast.info("Processing commission, please wait...");

    try {
      let response;
      if (isBulk) {
        console.log("VIEW PAYLOAD is bulk true++++++++++++", {
          otp: state.otp,
          invoice_number: Object.keys(selectedDocumentIds),
          partnership_id,
          partner_invoice_number: invoiceNumber,
          role_id: role_id
        });

        response = await verifyGroupInvoiceOtp({
          invoice_number: Object.keys(selectedDocumentIds),
          otp: state.otp,
          partnership_id,
          partner_invoice_number: invoiceNumber,
          role_id: role_id
        });
      } else {
        console.log("VIEW PAYLOAD++++++++++++", {
          otp: state.otp,
          document_ids: documentIdsArray,
          partnership_id,
        });

        response = await verifyInvoiceOtp({
          otp: state.otp,
          document_ids: documentIdsArray,
          partnership_id,
          partner_invoice_number: invoiceNumber,
          mobileNumber: state.mobileNumber,
          role_id: role_id
        });
      }

      if (response?.data?.result.paymentResponse?.payuUrl && response?.data?.result?.paymentResponse?.payUPayload) {
        const payuUrl = response.data.result.paymentResponse.payuUrl;
        const payuPayload = response.data.result.paymentResponse.payUPayload;
        if (payuPayload?.txnid) setTxnid(payuPayload.txnid);

        console.log("💳 [handleProceedToPayViaOtp] Amount being sent to PayU:", payuPayload?.amount);

        toast.success("Redirecting to payment gateway...");
        setRedirecting(true);

        // Create a dynamic form for redirection with full payload
        const form = document.createElement("form");
        form.method = "POST";
        form.action = payuUrl;

        // Append all payload parameters as hidden inputs
        Object.entries(payuPayload).forEach(([key, value]) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          input.value = value;
          form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit(); // Submit the form to PayU
      } else {
        throw new Error("Failed to process commission.");
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.error || "Failed to process commission.";
      setErrorMessage(errorMsg);
      toast.error(errorMsg);
    }

    setProcessing(false);
  };

  return (
    <Fragment>
      <Modal isOpen={isOpen} toggle={toggle} size="lg" backdrop="static">
        <div ref={componentRef} className="print_page m-15 p-0">


          {activeStep === 0 && (
            <>
              <ModalHeader toggle={toggle} className="pb-0 mb-0 border-0">
                {loading ? "Fetching Invoice Details..." : "Invoice Details"}
              </ModalHeader>
              <ModalBody>
                {loading ? (
                  <GetLoader />
                ) : errorMessage ? (
                  <div className="text-center text-danger">
                    <h5>{errorMessage}</h5>
                    <Button color="danger" onClick={toggle}>
                      Close
                    </Button>
                  </div>
                ) : (
                  <>

                    <Row>
                      <Col xl="12" md="12" className="pl-2 pr-2">
                        <table
                          borderless
                          style={{
                            borderCollapse: "collapse",
                            width: "100%",
                          }}
                        >
                          <thead
                            style={{
                              background: "#f2f2f2",
                              fontSize: "14px",
                            }}
                          >
                            <tr>
                              <th
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "center",
                                }}
                              >
                                {"Particulars"}
                              </th>
                              <th
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "center",
                                }}
                              >
                                {"Amount (INR)"}
                              </th>
                            </tr>
                          </thead>
                          <tbody style={{ fontSize: "14px" }}>

                            <tr>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "left",
                                }}
                              >
                                Total Documents
                              </td>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "center",
                                }}
                              >
                                {calculation?.total_documents || 0}
                              </td>
                            </tr>

                            <tr>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "left",
                                }}
                              >
                                {`Total Cost`}
                              </td>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "center",
                                }}
                              >
                                {convertToRupees(
                                  calculation?.total_premium_amount || 0,
                                  true
                                )}
                              </td>
                            </tr>

                            <tr>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "left",
                                }}
                              >
                                {`Total Commission`}
                              </td>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "center",
                                }}
                              >
                                {convertToRupees(
                                  calculation?.total_commission_amount || 0,
                                  true
                                )}
                              </td>
                            </tr>

                            <tr>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "left",
                                }}
                              >
                                {`Total Amount`}
                              </td>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "center",
                                }}
                              >
                                {convertToRupees(
                                  calculation?.base_amount_payable || 0,
                                  true
                                )}
                              </td>
                            </tr>

                            <tr>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "left",
                                }}
                              >
                                {"GST @ 18%"}
                              </td>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "center",
                                }}
                              >
                                {convertToRupees(calculation?.gst_amount || 0)}
                              </td>
                            </tr>

                            <tr>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "left",
                                }}
                              >
                                {"TDS @ 2%"}
                              </td>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "center",
                                }}
                              >
                                {convertToRupees(calculation?.tds_amount || 0)}
                              </td>
                            </tr>

                            {/* Cancelled documents details - only show entire CN section if there are cancelled documents */}
                            {calculation?.total_cancelled_documents > 0 && (
                              <>
                                <tr>
                                  <td
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "8px",
                                      textAlign: "left",
                                    }}
                                    className="mb-1"
                                  >
                                    {"Invoice Gross Payable"}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                    className="mb-2"
                                  >
                                    {convertToRupees(
                                      calculation?.net_payable_amount || 0,
                                      true
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="2" style={{ border: "1px solid #ddd", padding: "6px 8px", backgroundColor: "#fff3cd", fontWeight: "bold", fontSize: "12px", color: "#856404" }}>
                                    CN (Cancelled Documents) Details
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>
                                    Total Cancelled Documents
                                  </td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                    {calculation?.total_cancelled_documents}
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>
                                    Total Cancelled Cost
                                  </td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                    {convertToRupees(calculation?.total_premium_amount_of_cancelled_documents || 0, true)}
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>
                                    Total MSC CN
                                  </td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                    {convertToRupees(calculation?.total_commission_amount_of_cancelled_documents || 0, true)}
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>
                                    CN Gross Payable
                                  </td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                    {convertToRupees(calculation?.base_amount_payable_for_cancelled_documents || 0, true)}
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>
                                    GST (18%)
                                  </td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                    {convertToRupees(calculation?.gst_amount_for_cancelled_documents || 0)}
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>
                                    TDS @ 2%
                                  </td>
                                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                    {convertToRupees(calculation?.tds_amount_for_cancelled_documents || 0)}
                                  </td>
                                </tr>
                              </>
                            )}

                          </tbody>

                          <tfoot>
                            {calculation?.total_cancelled_documents > 0 && (
                              <tr>
                                <td
                                  style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}
                                  className="mb-1"
                                >
                                  {"Gross CN Amount"}
                                </td>
                                <td
                                  style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}
                                  className="mb-2"
                                >
                                  {convertToRupees(calculation?.net_payable_amount_for_cancelled_documents || 0, true)}
                                </td>
                              </tr>
                            )}
                            <tr>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "left",
                                  fontWeight: "bold",
                                }}
                                className="mb-1"
                              >
                                {"Total Amount Payable"}
                              </td>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "center",
                                  fontWeight: "bold",
                                  color: "#28a745",
                                }}
                                className="mb-2"
                              >
                                {convertToRupees(
                                  calculation?.net_payable_amount_for_cancelled_documents
                                    ? calculation?.net_payable_amount -
                                    calculation?.net_payable_amount_for_cancelled_documents
                                    : calculation?.net_payable_amount || 0,
                                  true
                                )}
                              </td>
                            </tr>

                          </tfoot>

                        </table>
                      </Col>
                    </Row>

                    <Row>
                      <Col className="text-center mt-3">
                        <Button
                          color="success"
                          size="md"
                          // onClick={handleProceedToPay}
                          onClick={handleNext}
                          disabled={processing || redirecting}
                        >
                          {processing ? "Processing..." : redirecting ? "Redirecting..." : "Next"}
                        </Button>
                      </Col>
                    </Row>
                  </>
                )}
              </ModalBody>
            </>

          )}

          {activeStep === 1 && (
            <>
              <ModalHeader toggle={toggle} className="pb-0 mb-0 border-0">
                {loading ? "Loading..." : "Confirm Commission invoice Creation and Proceed to Pay."}
              </ModalHeader>
              <ModalBody>
                {loading ? (
                  <GetLoader />
                ) : errorMessage ? (
                  <div className="text-center text-danger">
                    <h5>{errorMessage}</h5>
                    <Button color="danger" onClick={toggle}>
                      Close
                    </Button>
                  </div>
                ) : (
                  <>
                    <Form onSubmit={handleSubmit(setOtpResquest)}>
                      <Row>
                        <Col xl="12" md="12" className="pl-2 pr-2">
                          <table
                            borderless
                            style={{
                              borderCollapse: "collapse",
                              width: "100%",
                            }}
                          >
                            <thead
                              style={{
                                background: "#f2f2f2",
                                fontSize: "14px",
                              }}
                            >
                              <tr>
                                <th
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  {"Document No."}
                                </th>
                                {isBulk ?
                                  <th
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {"Base Amount (INR)"}
                                  </th>
                                  :
                                  <th
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {"Premium Amount (INR)"}
                                  </th>
                                }
                                <th
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  {"Commission Amount (INR)"}
                                </th>
                                <th
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  {"Payable Amount without taxes (INR)"}
                                </th>
                                <th
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  {"GST 18% (INR)"}
                                </th>
                                <th
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  {"TDS 2% (INR)"}
                                </th>
                                <th
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  {"Amount Payable (INR)"}
                                </th>
                                {isBulk && (
                                  <th
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {"Status"}
                                  </th>
                                )}

                              </tr>
                            </thead>
                            <tbody style={{ fontSize: "14px" }}>
                              {documentCommissionDetails.map((doc, index) => (
                                <tr key={index}>
                                  <td
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "8px",
                                      textAlign: "left",
                                    }}
                                  >
                                    {doc.documentCode}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "8px",
                                      textAlign: "right",
                                    }}
                                  >
                                    {convertToRupees(doc?.memberPremium || 0, true)}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "8px",
                                      textAlign: "right",
                                    }}
                                  >
                                    {convertToRupees(doc?.commissionAmount || 0, true)}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "8px",
                                      textAlign: "right",
                                    }}
                                  >
                                    {convertToRupees(doc?.baseAmount || 0, true)}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "8px",
                                      textAlign: "right",
                                    }}
                                  >
                                    {convertToRupees(doc?.gstAmount || 0, true)}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "8px",
                                      textAlign: "right",
                                    }}
                                  >
                                    {convertToRupees(doc?.tdsAmount || 0, true)}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #ddd",
                                      padding: "8px",
                                      textAlign: "right",
                                    }}
                                  >
                                    {convertToRupees(doc?.netPayableAmt || 0, true)}
                                  </td>
                                  {isBulk && (
                                    <td
                                      style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                        textAlign: "left",
                                      }}
                                    >
                                      <Badge
                                        color={
                                          doc?.status?.toUpperCase() === "ACTIVE"
                                            ? "success"
                                            : "warning"
                                        }
                                      >
                                        {doc?.status}
                                      </Badge>
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </tbody>

                            <tfoot>
                              <tr>
                                <td
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    textAlign: "left",
                                  }}
                                  className="mb-1"
                                >
                                  {"Grand Total"}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    textAlign: "right",
                                  }}
                                >
                                  {convertToRupees(
                                    calculation?.total_premium_amount_of_cancelled_documents
                                      ? (calculation?.total_premium_amount - calculation?.total_premium_amount_of_cancelled_documents)
                                      : calculation?.total_premium_amount || 0,
                                    true)}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    textAlign: "right",
                                  }}
                                >
                                  {convertToRupees(
                                    calculation?.total_commission_amount_of_cancelled_documents
                                      ? (calculation?.total_commission_amount - calculation?.total_commission_amount_of_cancelled_documents)
                                      : calculation?.total_commission_amount || 0,
                                    true)}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    textAlign: "right",
                                  }}
                                >
                                  {convertToRupees(
                                    calculation?.base_amount_payable_for_cancelled_documents
                                      ? (calculation?.base_amount_payable - calculation?.base_amount_payable_for_cancelled_documents)
                                      : calculation?.base_amount_payable || 0,
                                    true)}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    textAlign: "right",
                                  }}
                                >
                                  {convertToRupees(
                                    calculation?.gst_amount_for_cancelled_documents
                                      ? (calculation?.gst_amount - calculation?.gst_amount_for_cancelled_documents)
                                      : calculation?.gst_amount || 0,
                                    true)}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    textAlign: "right",
                                  }}
                                >
                                  {convertToRupees(
                                    calculation?.tds_amount_for_cancelled_documents
                                      ? (calculation?.tds_amount - calculation?.tds_amount_for_cancelled_documents)
                                      : calculation?.tds_amount || 0,
                                    true)}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    textAlign: "right",
                                  }}
                                >
                                  {convertToRupees(
                                    calculation?.net_payable_amount_for_cancelled_documents
                                      ? (calculation?.net_payable_amount - calculation?.net_payable_amount_for_cancelled_documents)
                                      : calculation?.net_payable_amount || 0,
                                    true)}
                                </td>
                                {isBulk && <td style={{ border: "1px solid #ddd" }}></td>}
                              </tr>
                            </tfoot>
                          </table>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="text-left mt-3">
                          {/* <FormGroup className="d-flex align-items-center">
                          <span className="mr-3">Do you want to enter your Invoice No.?</span>

                          <FormGroup check inline className="mb-0 mr-2">
                            <Label check className="d-flex align-items-center">
                              <Input
                                type="radio"
                                name="invoiceRadio"
                                checked={wantInvoice === true}
                                onChange={() => setWantInvoice(true)}
                              />
                              <span className="ml-1" style={{
                                marginLeft: '5px',
                                fontSize: '0.9rem',
                                verticalAlign: 'middle'
                              }}>Yes</span>
                            </Label>
                          </FormGroup>

                          <FormGroup check inline className="mb-0">
                            <Label check className="d-flex align-items-center">
                              <Input
                                type="radio"
                                name="invoiceRadio"
                                checked={wantInvoice === false}
                                onChange={() => setWantInvoice(false)}
                              />
                              <span className="ml-1" style={{
                                marginLeft: '5px',
                                fontSize: '0.9rem',
                                verticalAlign: 'middle'
                              }}>No</span>
                            </Label>
                          </FormGroup>
                        </FormGroup> */}

                          {isGSTReg === true && (
                            <Row className="mt-2">
                              <Col md={6}>
                                <FormGroup>
                                  <Label for="invoiceNumber">Invoice Number</Label>
                                  <Input
                                    type="text"
                                    id="invoiceNumber"
                                    name="invoiceNumber"
                                    value={invoiceNumber}
                                    onChange={(e) => handleInvoiceNumberChange(e.target.value)}
                                    // innerRef={register({ required: isGSTReg })}
                                    innerRef={register({
                                      required: isGSTReg,
                                      maxLength: {
                                        value: 20,
                                        message: "Invoice number cannot exceed 20 characters"
                                      }
                                    })}
                                    placeholder="Enter invoice number"
                                  />
                                  <span style={{ color: "red" }}>
                                    {errors.invoiceNumber && errors.invoiceNumber.type === "required" && (<span>Invoice number is required</span>)}
                                    {errors.invoiceNumber && errors.invoiceNumber.type === "maxLength" && (<span>{errors.invoiceNumber.message}</span>)}
                                  </span>
                                </FormGroup>
                              </Col>
                            </Row>
                          )}
                        </Col>
                      </Row>
                      {!offlinePayment && (
                        <Row>
                          <Col xl="12" md="12" className="text-left">
                            <FormGroup>
                              <span>
                                <strong>Note:</strong> As you proceed with the payment, a commission invoice should be generated concurrently for the corresponding transaction. You can find Commission invoices in Commission tab.
                              </span>
                            </FormGroup>
                          </Col>
                        </Row>
                      )}

                      {!offlinePayment
                        ?
                        (
                          <Row>
                            <Col className="text-left mt-3">
                              <FormGroup check className="mt-3">
                                <Label check>
                                  <Input
                                    type="checkbox"
                                    checked={termsAccepted}
                                    onChange={() => setTermsAccepted(!termsAccepted)}
                                  />{' '}
                                  I've read the <a
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      toggleTermsModal();
                                    }}
                                    style={{
                                      color: '#007bff',
                                      textDecoration: 'underline'
                                    }}
                                  >
                                    terms & conditions
                                  </a>
                                </Label>
                              </FormGroup>
                            </Col>
                            <Col className="text-right mt-3">
                             <Button
                                color="success"
                                size="md"
                                // onClick={handleProceedToPay}
                                onClick={handleNext}
                                // type="submit"
                                disabled={!termsAccepted}
                              >
                                {processing ? "Processing..." : redirecting ? "Redirecting..." : "Send Link"}
                              </Button>
                              <Button
                                className="ml-2"
                                color="success"
                                size="md"
                                // onClick={handleProceedToPay}
                                // onClick={handleSubmit}
                                type="submit"
                                disabled={!termsAccepted}
                              >
                                {processing ? "Processing..." : redirecting ? "Redirecting..." : "Proceed to Pay"}
                              </Button>
                            </Col>
                          </Row>
                        )
                        :
                        (
                          <Row>
                            {/* Remark Field */}
                            <Col xl="4" md="4" className="mt-3">
                              <FormGroup>
                                <Label for="remark">
                                  Remark (<span style={{ color: "red" }}>* required</span>)
                                </Label>
                                <Input
                                  type="text"
                                  id="remark"
                                  name="remark"
                                  {...register("remark", { required: true })}
                                  placeholder="Enter Remark"
                                  onChange={(e) => {
                                    setValue("remark", e.target.value);
                                    setRemark(e.target.value)
                                  }}
                                />
                              </FormGroup>
                            </Col>

                            {/* File Upload */}
                            <Col xl="4" md="4" className="mt-3">
                              <FileUploadComponent
                                register={register}
                                name="file"
                                setValue={setValue}
                                trigger={trigger}
                                getValues={getValues}
                                data={""}
                                add={getValues("file")?.length > 0 ? false : true}
                              />
                              <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                                * File is required
                              </div>
                            </Col>

                            {/* Terms & Conditions */}
                            <Col xl="4" md="4" className="mt-3">
                              <FormGroup check>
                                <Label check>
                                  <Input
                                    type="checkbox"
                                    checked={termsAccepted}
                                    onChange={() => setTermsAccepted(!termsAccepted)} // Toggle terms acceptance
                                  />{' '}
                                  I've read the <a
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      toggleTermsModal();
                                    }}
                                    style={{
                                      color: '#007bff',
                                      textDecoration: 'underline'
                                    }}
                                  >
                                    terms & conditions
                                  </a>
                                </Label>
                              </FormGroup>
                            </Col>

                            {/* Submit Button */}
                            <Col className="text-right mt-3">
                              <Button
                                color="success"
                                size="md"
                                onClick={handleOfflineSubmit}
                                disabled={
                                  !(
                                    remark?.trim() &&
                                    getValues("file")?.length &&
                                    termsAccepted
                                  )
                                }
                              >
                                Proceed to Finance
                              </Button>
                            </Col>
                          </Row>
                        )
                      }

                    </Form>
                  </>
                )}
              </ModalBody>

            </>

          )}

          {activeStep === 2 && (
            <>
              <ModalHeader toggle={toggle}>
                Send Payment Link
              </ModalHeader>

              <ModalBody>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="email">
                        Email Address <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Enter Email Address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </FormGroup>
                  </Col>

                  <Col md={12}>
                    <FormGroup>
                      <Label for="mobileNumber">
                        Mobile Number <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="tel"
                        id="mobileNumber"
                        name="mobileNumber"
                        placeholder="Enter Mobile Number"
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                        maxLength={10}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row className="mt-2">

                  <Col md={12}>

                    <FormGroup check>

                      <Label check>
                        <Input
                          type="checkbox"
                          checked={confirmDetails}
                          onChange={() => setConfirmDetails(!confirmDetails)}
                        />{" "}
                        I confirm that the above email address and mobile number are correct.
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>


                <Row className="mt-3">
                  <Col className="text-right">
                    <Button
                      color="secondary"
                      className="mr-2"
                      onClick={() => setActiveStep(1)}
                    >
                      Back
                    </Button>

                    <Button
                      color="success"
                      disabled={
                        !confirmDetails ||
                        !email.trim() ||
                        !mobileNumber.trim()
                      }
                      onClick={handleSendLink}
                    >
                      Send Link
                    </Button>
                  </Col>
                </Row>
              </ModalBody>
            </>
          )}

        </div>
      </Modal>

      {/* Terms and Conditions Modal */}
      <Modal isOpen={termsModalOpen} toggle={toggleTermsModal} size="lg">
        <ModalHeader toggle={toggleTermsModal}>Terms and Conditions</ModalHeader>
        <ModalBody sx={{ maxHeight: '400px', overflowY: 'auto', scrollbarWidth: "none", msOverflowStyle: "none" }}>
          <p>I hereby agree that I am the Authorized Signatory of Proprietorship / Partnership Firm / Company/ LLP (hereinafter referred as "Entity") duly authorized to digitally sign the invoices, and receive One Time Password (OTP) on my registered mobile number for business purpose on behalf of the said Entity. I hereby provide my consent for the above and to receive OTP on the said number to authenticate details on behalf of the Entity. I understand and agree that the OTP provided herein;</p>

          <p>- shall be used only for the purpose of authenticating the identity of the Authorized Signatory on behalf of the said Entity through the Mobile based OTP system.,</p>
          <p>- shall be used to avail my consent for digitally signing the invoices (using my Digital Signature) specific under this Travel Care  / Paperless arrangement with Europ Assistance India Private Limited ("EAI") and not for any other purpose otherwise.</p>
          <p>I hereby declare that the details furnished above are true and correct to the best of my knowledge and belief. In case any of the above information is found to be false or untrue or misleading or misrepresenting, I am aware that I may be held liable for it. I hereby authorize sharing of the information furnished herewith to be used for business purpose agreed herein.</p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleTermsModal}>Close</Button>
          <Button color="primary" onClick={handleAgreeClick}>I Agree</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={otpModalOpen} toggle={toggleOtpModal} size="md">
        <ModalHeader toggle={toggleOtpModal}>OTP is shared to {businessPartnerInfo.phone_number}.</ModalHeader>
        <ModalBody style={{ maxHeight: '50%', overflowY: 'auto' }}>
          <Row>
            <Col xs="8">
              <FormGroup>
                <Label for="otp">Submit your OTP!</Label>
                <OtpInput
                  value={state.otp}
                  onChange={handleChange}
                  numInputs={6}
                  separator={<span style={{ width: '12px' }}></span>}
                  isInputNum={true}
                  shouldAutoFocus={true}
                  inputStyle={{
                    border: '1px solid #CFD3DB ',
                    borderRadius: '9px',
                    width: '50px',
                    height: '50px',
                    fontSize: '16px',
                    fontWeight: '400',
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs="1">
              <Button
                color="primary"
                size="md"
                type="submit"
                onClick={handleProceedToPayViaOtp}
                disabled={loading ? loading : loading}
              >
                {processing ? "Processing..." : redirecting ? "Redirecting..." : "Submit"}

              </Button>
            </Col>
          </Row>

        </ModalBody>
      </Modal>
      <Modal isOpen={mobileNoModalOpen} toggle={toggleMobileNoModal} size="md">
        <ModalHeader toggle={toggleMobileNoModal}>Mobile Number Registered With Us</ModalHeader>
        <ModalBody style={{ maxHeight: '50%', overflowY: 'auto' }}>
          <Form onSubmit={handleSubmit(submitNumberToGetOtp)}>
            <Row>
              <Col xs="8">
                <FormGroup>
                  <Label for="mobileNumber">Please click submit to get the OTP</Label>
                  <Input
                    type="text"
                    id="mobileNumber"
                    name="mobileNumber"
                    value={state.mobileNumber}
                    onChange={(e) => handleMobileNumberChange(e.target.value)}
                    innerRef={register({ required: true, pattern: /^[6-9]\d+$/, minLength: 10, })}
                    placeholder="Enter mobile number"
                  />
                  <span style={{ color: "red" }}>
                    {errors.mobileNumber && errors.mobileNumber.type === "required" && (<span>Mobile number is required</span>)}
                    {errors.mobileNumber && errors.mobileNumber.type === "pattern" && (<span>Mobile number is not valid</span>)}
                    {errors.mobileNumber && errors.mobileNumber.type === "minLength" && (<span>Mobile number length must be 10</span>)}
                  </span>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="1">
                <Button
                  color="primary"
                  size="md"
                  type="submit"
                  onClick={handleSubmit}
                  disabled={loading ? loading : loading}
                >
                  {processing ? "Processing..." : redirecting ? "Redirecting..." : "Submit"}

                </Button>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default ClaimInvoice;
